import type { Mention } from '@fluenceur/types';
import { MentionPlatform, MentionType } from '@fluenceur/types';

/**
 * i18n key for a mention's origin/type label (Story / Post / Mention / Template),
 * or null when the type carries no label. Single source shared by the media chip
 * and the origin badge so the mapping never drifts.
 */
export function mentionOriginLabelKey(
  mention: Pick<Mention, 'mentionType' | 'platform'>
): string | null {
  switch (mention.mentionType) {
    case MentionType.STORY:
      return 'mentions.origin.story';
    case MentionType.CAPTION:
      return mention.platform === MentionPlatform.TIKTOK
        ? 'mentions.origin.mention'
        : 'mentions.origin.post';
    case MentionType.TEMPLATE:
      return 'mentions.origin.template';
    default:
      return null;
  }
}
